module.exports = __webpack_public_path__ + "static/media/renewal_tools.fa60d8d2.png";